let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kYvCt")).then(() => parcelRequire('628Dr'));